import { authSiseUserApi } from "../sevices/quoteService";

export const authSiseUser = () => async (dispatch) => {
  await dispatch(authSiseUserApi());
};